import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import AppRoutes from "./routes/AppRoutes";
import ErrorBoundary from "./components/ErrorBoundary";
import Footer from "./components/Footer/Footer";
import LocomotiveScroll from "locomotive-scroll";
import "react-toastify/dist/ReactToastify.css";
import "./styles/index.css";

const App = () => {
    // 5.3: was constructed on every render and never destroyed.
    useEffect(() => {
        const scroll = new LocomotiveScroll({});
        return () => scroll.destroy();
    }, []);

    return (
        <ErrorBoundary>
            <AnimatePresence mode="wait" initial={true}>
                <BrowserRouter>
                    <AppRoutes />
                    <Footer />
                </BrowserRouter>
            </AnimatePresence>
        </ErrorBoundary>
    );
};

export default App;
